var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"col-3"},[_c('icon',{attrs:{"icon":this.icon}}),_vm._v(" "+_vm._s(this.title)+"\n    ")],1),_c('div',{staticClass:"col-9"})])}
var staticRenderFns = []

export { render, staticRenderFns }